import { create } from 'zustand';

// One board group's child node, mapped to a ready-to-use "Improve with AI"
// attachment. `text` is the already-extracted content (via generateKnowledgeBase),
// captured on the board so it's ready the moment the modal opens. `url`/`thumbnail`,
// when present, let the chat render the attachment as its social platform card
// (Instagram/TikTok/YouTube).
export interface SeededBrandAttachment {
  // Source board node id — used to dedupe (avoid attaching the same node twice)
  // when picking sources via the chat's "@" mention.
  id?: string;
  label: string;
  text: string;
  url?: string;
  thumbnail?: string;
  // Source board node type (e.g. 'contentNode', 'documentNode', 'textNode') and,
  // for content nodes, the resolved social platform ('fb-ads', 'tiktok', …). Used
  // to render a block-type placeholder icon when there's no (usable) thumbnail.
  nodeType?: string;
  platform?: string;
}

// Drives the brand "Improve with AI" modal opened in-place on a board from a
// group's "Brand" toolbar option. The toolbar sets `open` with the target brand
// and the group's nodes; a board-level host renders the modal seeded with them.
interface BrandBoostState {
  open: { brandId: string; attachments: SeededBrandAttachment[] } | null;
  openBrandModal: (payload: { brandId: string; attachments: SeededBrandAttachment[] }) => void;
  closeBrandModal: () => void;
}

export const useBrandBoostStore = create<BrandBoostState>(set => ({
  open: null,
  openBrandModal: payload => set({ open: payload }),
  closeBrandModal: () => set({ open: null }),
}));
